import React from "react";
import { any, async, fromJSX, navigate, nothing, Updater, Widget } from "widgets-for-react";
import { EventFormLayout } from "./eventForm.layout";
import { EventFormState, EventFormStateUpdaters } from "./eventForm.state";
import { PostMessage } from "../iframe/iframe.state";
import { ConfirmationMessage, RegistrationType, SubmissionMessage } from "./eventForm.utils";
import { ecommerceGA4, EcommerceItem } from "../../utils/datalayer";
import { EventTemplate } from "../models/Events/Events";
import { loader } from "../sharedLayout/loader";
import i18next from "i18next";
import { EventPage } from "../cmsPage/cmsPageState";

export const EventFormWidget = (
  params: { eventId: string },
  state: EventFormState
): Widget<Updater<EventFormState>> => {
  const { eventData, pageData } = state
  return any<Updater<EventFormState>>([
    async<EventTemplate>(eventData).map(EventFormStateUpdaters.updateEventData),
    async<EventPage>(pageData).map(EventFormStateUpdaters.updatePageData),
    eventData.kind == "loaded" && pageData.kind == "loaded" ?
      fromJSX((setState) => (
        <EventFormLayout 
          {...params} 
          embedCode={""} 
          eventData={eventData.value} 
          pageData={pageData.value} 
          handlePostMessage={(m: PostMessage) => handlePostMessage(m, state, setState)} 
        />
      ))
    : nothing(),

    // Display error message when loading of EventData fails
    eventData.kind == 'loading' ? loader(false) : nothing(),

    // Display error message when loading of EventData fails
    eventData.kind == 'failed' ? fromJSX(() => <>{i18next.t('errorPage:generalErrorMessage')}</>) : nothing()
  ])
}

const handlePostMessage = (m: PostMessage, state: EventFormState, setState: (_: Updater<EventFormState>) => void) => {
  if (m.type == "submission") {
    // Save submission data
    setState((s0) => ({...s0, submissionData: m as SubmissionMessage}))
  } else if (m.type == "confirmation") {
    const message = m as ConfirmationMessage
    // Verify sent confirmation relates to submission data
    if (state.submissionData && message.session_id == state.submissionData.session_id && message.is_confirmed)
    // Instead of sending submission data, we're going to redirect the user to a ThankYou page
    // sendSubmissionToGA(state.submissionData)
    navigate("/bedankt-voor-je-aanmelding")
  } else {
    console.warn(`No handler created for postMessage event: ${m.type}`)
  }
}

const sendSubmissionToGA = (data: SubmissionMessage) => {
  const priceExcl = parseFloat(data.price_exl_vat.replace(/[^\d.-]/g, ''));
  const priceIncl = parseFloat(data.price_inc_vat.replace(/[^\d.-]/g, ''));
  const transactionId  = `n${data.eventTemplate_id}-${Math.floor(new Date().getTime() / 1000)}`
  const item: EcommerceItem = {
    item_name: data.eventTemplate_name,
    item_id: data.eventTemplate_id,
    price: priceExcl,
    item_brand: 'unknown',
    item_category: RegistrationType[data.registration_type],
    item_category2: data.eventTemplate_name,
    quantity: data.participantsCount
  }

  ecommerceGA4(priceIncl, transactionId, [item])
}
